import { gql } from "@apollo/client";

export const QUERY_FORM3454E_VERSION = gql`
  query studentForm3454E(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3454E(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      needsDifferent
      needsDifferentAreas
      achievementDiscrepancy
      achievementDiscrepancyAreas
      specificLearningDisability
      specificLearningDisabilityArea
      specializedInstruction
      memberCertify
      memberCertifyName
      formAction
      formStatus
    }
  }
`;
